module.exports = __webpack_public_path__ + "static/media/home3.40bcaae1.png";